import { render } from "./AccountDefaultSettings.vue?vue&type=template&id=5729dbaa&scoped=true"
import script from "./AccountDefaultSettings.vue?vue&type=script&lang=js"
export * from "./AccountDefaultSettings.vue?vue&type=script&lang=js"

import "./AccountDefaultSettings.vue?vue&type=style&index=0&id=5729dbaa&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5729dbaa"]])

export default __exports__